module.exports = __webpack_public_path__ + "assets/img/iOS.06e97472.svg";